/** Snackbar text for a finished enrichment, including contacts skipped because credits ran out */
export function describeEnrichmentResult(result, enrichmentType) {
    var _a;
    const parts = [`Enriched ${(_a = result.enrichedCount) !== null && _a !== void 0 ? _a : 0} contacts with ${enrichmentType}`];
    if (result.chargedCredits)
        parts.push(`${result.chargedCredits.toLocaleString()} credits used`);
    if (result.truncatedCount)
        parts.push(`${result.truncatedCount} skipped: not enough credits`);
    return parts.join(" · ");
}
